import React from 'react';
import cl from 'classnames';
import styles from './imageViewerStyle.module.scss';

type ImageViewerProps = {
  src?: string | null;
  close: () => void;
};

export const ImageViewer = ({ src, close }: ImageViewerProps) => {
  return (
    <div
      className={cl(styles.modal, src && styles.show)}
      onClick={() => {
        close();
      }}
    >
      {src && (
        <img
          src={src}
          alt=""
          className={styles.img}
          onClick={() => {
            close();
          }}
        />
      )}
    </div>
  );
};

export default ImageViewer;
